import React, { useMemo, useState } from 'react';

import { CallRequestByTheme } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme';
import { ITheme, TSendRequestHandle } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/types';
import IconVk from '@r1-frontend/ui-react/organisms/Footer/components/icons/vkSupport.svg';
import { ListItemButton } from '@r1-frontend/ui-react/organisms/Footer/components/LinkItem/ListItemButton';
import { ListItemLi } from '@r1-frontend/ui-react/organisms/Footer/components/LinkItem/ListItemLi';
import { POLICY_PAGE_LINK } from '@r1-frontend/shared/constants/routes';

import * as ST from './styled';

interface ISupport {
    sendRequestHandle: TSendRequestHandle,
    onChangeHandle: (theme: ITheme) => void,
    openChatHandler: () => void,
    contactEmail?: string,
    phone?: string,
    requestLink?: string,
    policyLink?: string,
    withChat?: boolean,
}

const SOCIAL_NETWORKS = [
    {
        href: 'https://vk.me/domru',
        network: 'Vk',
        text: 'ВKонтакте',
        icon: IconVk,
    },
];

export const Support = ({
    onChangeHandle,
    openChatHandler,
    requestLink,
    contactEmail,
    policyLink = POLICY_PAGE_LINK,
    phone,
    sendRequestHandle,
    withChat,
}: ISupport) => {
    const [isCallbackOpen, setIsCallbackOpen] = useState(false);

    const onCallbackClick = () => {
        setIsCallbackOpen(true);
    };

    const handleClosePopup = () => {
        setIsCallbackOpen(false);
    };

    const phoneLink = useMemo(() => phone?.replace(/\D/g, ''), [phone]);

    return <>
        <ST.Header>Как с нами связаться</ST.Header>
        <ST.RowNav>

            <ST.List>
                {SOCIAL_NETWORKS.map(({ href, network, text, icon }) => (
                    <ST.ListItem key={text} data-test={network}>
                        <ST.LinkWithIcon href={href}>
                            <img src={icon} alt={`Техподдержка в ${network}`}/>
                            {`Написать ${text}`}
                        </ST.LinkWithIcon>
                    </ST.ListItem>))}
            </ST.List>

            <ST.List>
                {withChat && <ListItemButton onClick={openChatHandler} dataTest='chat' text={'Написать в чат'}/>}
                {contactEmail && <ListItemLi link={`mailto:${contactEmail}`} dataTest='email' text={'Написать на почту'}/>}

                <ListItemButton onClick={onCallbackClick} dataTest='request' text={'Задать вопрос или сообщить о проблеме'}/>

                {requestLink && <ListItemLi link={requestLink} dataTest='cause' text={'Создать обращение'} passHref/>}

            </ST.List>
        </ST.RowNav>

        <ST.RowCallback>
            <ST.LinkPhone
                href={`tel:+${phoneLink}`}
                className='js-calltouch-phone'
                data-test='phone'
            >
                {phone}
            </ST.LinkPhone>

            <ST.LinkCallBack onClick={onCallbackClick} data-test='call-back-order'>
                Заказать обратный звонок
            </ST.LinkCallBack>
        </ST.RowCallback>


        <CallRequestByTheme
            openChatHandler={openChatHandler}
            onChangeHandle={onChangeHandle}
            isOpen={isCallbackOpen}
            onClose={handleClosePopup}
            sendRequestHandle={sendRequestHandle}
            policyLink={policyLink}
            data-test='call-back-order-popup'
        />
    </>;
};


